import Loader, { LOADER_SIZE } from './loader';
export { LOADER_SIZE };
export default Loader;